import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'ai-landing-page',
})
export default class AILandingPage extends Vue {

    // -------------------------------------------------
    // Properties

    public landingPageActions = [
        {
            name: 'section 1',
            key: 'section-1',
        },
        {
            name: 'section 2',
            key: 'section-2',
        },
        {
            name: 'section 3',
            key: 'section-3',
        },
        {
            name: 'section 4',
            key: 'section-4',
        },
    ];


    // -------------------------------------------------
    // Actions

    public onSelectSection(item: any) {
        const aiLandingPage = this.$refs.aiLandingPage as HTMLElement;
        aiLandingPage.querySelectorAll('.ai-landing-page-item').forEach((elItem: any) => {
            elItem.style.display = 'none';
        });
        const activePage = aiLandingPage.querySelector(`.ai-landing-page-${item.key}`) as HTMLElement;
        activePage.style.display = 'block';
    }

    public onClose() {
        const aiLandingPage = this.$refs.aiLandingPage as HTMLElement;
        aiLandingPage.querySelectorAll('.ai-landing-page-item').forEach((item: any) => {
            item.style.display = 'none';
        });
        const activePage = aiLandingPage.querySelector(`.ai-landing-page-section`) as HTMLElement;
        activePage.style.display = 'block';
    }

    public onGenerate() {
        this.$router.push('/ai-playground/generate');
    }

    public onShowShowcase() {
        this.$router.push('/showcase-revamp?isPlayground=true');
    }

}
